"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Redirector = void 0;
var util_1 = require("@app/util");
var Redirector = /** @class */ (function () {
    function Redirector(options) {
        this.params = {};
        console.log('Redirector constructor');
        this._initSession();
        this.request = new util_1.Request(this.endpoint, this.session);
        this.initParams(); // get or cookies params
        this.initializeOptions(options);
        try {
            this.initConnections();
        }
        catch (e) {
            console.error('Redirector: initConnections error', e);
        }
    }
    Redirector.prototype.initParams = function () {
        var _this = this;
        console.log('Init params, lets search query params in url');
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        this.params.to = urlParams.get('to');
        this.params.toSource = urlParams.get('toSource');
        this.params.subId = urlParams.get('subId');
        this.params.other = urlParams.get('other');
        Object.keys(this.params).forEach(function (key) {
            if (!_this.params[key]) {
                console.log('deleted');
                delete _this.params[key];
            }
        });
    };
    Redirector.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Redirector: refresh, requesting new offer');
                        this.params.other = '1';
                        return [4 /*yield*/, this.initConnections()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Redirector.prototype._initSession = function () {
        if (window.bicrmTracking) {
            console.log('Redirector: bicrmTracking exists');
            this.session = window.bicrmTracking.session;
            this.shortId = this.session.getShortId();
        }
        else {
            throw new Error('Redirector: bicrmTracking not found');
        }
    };
    Redirector.prototype.initializeOptions = function (options) {
        if (!options.endpoint) {
            throw new Error('RedirectorOptions.endpoint is required');
        }
        if (!!options.delayMs) {
            this.delayMs = options.delayMs;
        }
        else {
            this.delayMs = 1000;
        }
        this.endpoint = options.endpoint.replace('[shortId]', this.shortId);
        this.onPing3Success = options.onPing3Success;
    };
    Redirector.prototype.initConnections = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, status, url;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.request.post(this.endpoint, this.params)];
                    case 1:
                        response = _b.sent();
                        status = response.status, url = response.url;
                        (_a = this.onPing3Success) === null || _a === void 0 ? void 0 : _a.call(this, response);
                        window.bicrmTracking.track('waiting_page_redirect', {
                            status: status,
                            redirect_url: url,
                        });
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ event: 'WaitingPageRedirect', status: status, redirect_url: url });
                        console.log('Redirector: initConnections', status, url);
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, _this.delayMs); })];
                    case 2:
                        _b.sent();
                        document.location = url;
                        return [2 /*return*/];
                }
            });
        });
    };
    return Redirector;
}());
exports.Redirector = Redirector;
